import React, { useCallback, useEffect, useState } from 'react';
import { GlobalBox } from 'components/Box/GlobalBox';
import { WarehouseRounded } from '@mui/icons-material';
import { Box, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { UnitsAccordion } from './UnitsAccordion';
import { graphRequest } from './graphRequest';
import { addDetails } from './addDetails';
import { animations } from 'helpers/animations';
import { useSearch } from 'hooks/useSearch';
import { LoadingComponent } from 'components/Loading/LoadingComponent';
import { TableInputs } from 'components/CardTable/TableInputs';
import { setWarehousesGraphsFilters } from 'redux/actions/warehousesGraphs/warehousesGraphsActions';

export const WarehousesGraphs = () => {
  const dispatch = useDispatch()
  const { setSnackbar, clearSearch, changeStation } = useSearch();
  const {  isLoading } = useSelector((state) => state.search);
  const { station } = useSelector((state) => state.warehousesGraphs);
  const [ data, setData ] = useState(null)
  const [ savedData, setSavedData ] = useState({})

  const handleSubmit = useCallback(async(e) => {
    e.preventDefault()
    if(!station) {
      setSnackbar("No se ha seleccionado alguna planta.")
      return
    }
    setData(null)
    if(savedData[station.id]) setTimeout(() => setData(savedData[station.id]), 10)
    else {  
      const resp = addDetails(await graphRequest(station.id, dispatch))
      setSavedData({...savedData, [station.id]: resp})
      setData(resp)
    }
    changeStation(station)
  }, [station, savedData, dispatch, setSnackbar, changeStation]);

  useEffect(() => {
    clearSearch();
  }, [clearSearch]);

  return (
    <>
      <GlobalBox
        icon={<WarehouseRounded />}
        title="Inventario de almacenes en tiempo real"
      >
        <Box sx={{marginTop: 2}}>
          <TableInputs
            reducer="warehousesGraphs"
            companies
            dispatchAction={setWarehousesGraphsFilters}
            submitAction={handleSubmit}
            loading={isLoading}
          />
        </Box>
        {
          data &&
          <Box className={animations.fadeIn}>
            <Grid container spacing={1} style={{ marginTop: 20 }}>
              {
                Object.keys(data).length > 0 &&
                  Object.keys(data).map(unitType => <UnitsAccordion 
                    key={unitType} 
                    data={data[unitType]} 
                    unitType={unitType}
                    setSavedData={setSavedData} 
                    savedData={savedData}
                  />)
              }
            </Grid>
          </Box>
        }
      </GlobalBox>
      {
        !data && isLoading && <LoadingComponent />
      }
    </>
  )
}
